import Vue from 'vue'
import Router from 'vue-router'
import HomeView from '../App.vue'
import ZhongyiSearch from '../views/ZhongyiSearch.vue'
import AdminDashboard from '../views/AdminDashboard.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/wenku',
      name: 'wenku-search',
      component: ZhongyiSearch,
    },
    {
      path: '/admin',
      name: 'admin-dashboard',
      component: AdminDashboard,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

export default router
